const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="o-rhythm">
  <p class="`);
                if ((context.has(`font_size`) ? context.get(`font_size`) : null)) {
                    this.echo(`has-`);
                    this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, (context.has(`font_size`) ? context.get(`font_size`) : null), `html`, null, true]));
                    this.echo(`-font-size`);
                }
                this.echo(`">
    This paragraph is `);
                if ((context.has(`font_size`) ? context.get(`font_size`) : null)) {
                    this.echo(`<b>`);
                    this.echo(this.env.getFilter('escape').traceableCallable(6, this.source)(...[this.env, (context.has(`font_size`) ? context.get(`font_size`) : null), `html`, null, true]));
                    this.echo(`</b>`);
                }
                else {
                    this.echo(`normal`);
                }
                this.echo(`.
    We help forward-thinking teams craft accessible design systems and progressive web apps.
  </p>
  <p>
    This paragraph is `);
                if ( !(context.has(`font_size`) ? context.get(`font_size`) : null)) {
                    this.echo(`also`);
                }
                this.echo(` normal.
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eleifend magna id risus rhoncus, sit amet placerat ligula vehicula. Proin neque dui, pellentesque non arcu sit amet, lacinia facilisis velit. Aenean in bibendum nulla. Nullam elementum neque vel ipsum iaculis, at accumsan dui auctor.
  </p>
</div>
`);
            }

            getTemplateName() {
                return `7ba40301be48ce67ac1bde9a21c84bfcbd31a8ad7548f6d06739508b175dff50`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `7ba40301be48ce67ac1bde9a21c84bfcbd31a8ad7548f6d06739508b175dff50`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '7ba40301be48ce67ac1bde9a21c84bfcbd31a8ad7548f6d06739508b175dff50');

let template = env.loadTemplate('7ba40301be48ce67ac1bde9a21c84bfcbd31a8ad7548f6d06739508b175dff50');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/font-size.twig", args: context }
     );
     return rendered;;
};